import React from 'react';
import { Link } from 'react-router-dom';
import { Button, FieldGroup } from '@ver-uds/react';
import LoaderIcon from 'uswds/dist/img/loader.svg';
import { AccountCategory } from 'eve-account-client';
import Section from './Section';
import { useEmployerCategoriesQuery } from '../services';

type OnButtonClick = { onEditButtonClick: () => void; editUrl?: never };
type EditUrl = { editUrl: string; onEditButtonClick?: never };
export type EmployerCategoryProps = { employerCategory?: AccountCategory } & (OnButtonClick | EditUrl);

const EmployerCategory = ({ onEditButtonClick, editUrl, employerCategory }: EmployerCategoryProps): JSX.Element => {
  const { isLoading, data: employerCategoriesData } = useEmployerCategoriesQuery();

  return (
    <Section title="Employer Category" data-testid="employer-category">
      {isLoading ? (
        <div className="margin-top-4 margin-bottom-3">
          Loading… <img src={LoaderIcon} alt="" className="height-2" />
        </div>
      ) : (
        <FieldGroup className="grid-row">
          <FieldGroup.Field name="Employer Category">
            {employerCategoriesData?.find(({ value }) => value === employerCategory?.category)?.displayName ?? '---'}
          </FieldGroup.Field>
        </FieldGroup>
      )}

      {editUrl && (
        <Link to={editUrl} className="usa-button usa-button--outline">
          Edit Employer Category
        </Link>
      )}

      {onEditButtonClick && (
        <Button variant="secondary" type="button" onClick={onEditButtonClick}>
          Edit Employer Category
        </Button>
      )}
    </Section>
  );
};

export default EmployerCategory;
